export default "/assets/images/smoky-gray.a4cf20fe7d7f93a9.jpg";